module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4a528d3de55bec9983bd0eb39777143b.png";